import React from 'react';
import { Link } from 'react-router-dom';
import "../App.css";
import { useTranslation } from 'react-i18next';
import PersonIcon from '@mui/icons-material/Person';
import BarChartIcon from '@mui/icons-material/BarChart';
import VideoIcon from '@mui/icons-material/VideoLibrary';
import SurveyIcon from '@mui/icons-material/Poll';
import RelatedIcon from '@mui/icons-material/Lightbulb';

const SideBar = () => {
  const { t } = useTranslation();

  const [isSmallScreen, setIsSmallScreen] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const itemStyle = {
    display: "flex",
    alignItems: "center",
    /*marginBottom: "40px",
    marginTop: '40px',*/
    cursor: "pointer", 
    textDecoration: "none", 
    color: 'var(--primary-white-color)',
    fontSize: "16px"
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column", 
      alignItems: "flex-start",
      /*justifyContent: "space-between", */
      backgroundColor: 'var(--primary-color)',
      height: "auto", 
      width: "fit-content", 
      color: 'var(--primary-white-color)',
      position: "fixed",
      top: 100,
      left: 0,
      padding: isSmallScreen ? "10px" : "20px", 
      boxSizing: "border-box",
      transition: "width 0.3s",    }}>
      <Link to="/dashsummary" style={itemStyle}>
        <BarChartIcon style={{ marginRight: isSmallScreen ? "0" : "10px", fontSize: "50px" }} />
        {!isSmallScreen && t('overviewSidebar')}
      </Link>
      <Link to="/dashvideosummary" style={itemStyle}>
        <VideoIcon style={{ marginRight: isSmallScreen ? "0" : "10px", fontSize: "50px" }} />
        {!isSmallScreen && t('videosSidebar')}
      </Link>
      <Link to="/dashusersummary" style={itemStyle}>
        <PersonIcon style={{ marginRight: isSmallScreen ? "0" : "10px", fontSize: "50px" }} />
        {!isSmallScreen && t('usersSidebar')}
      </Link>
      <Link to="/dashsurveysummary" style={itemStyle}>
        <SurveyIcon style={{ marginRight: isSmallScreen ? "0" : "10px", fontSize: "50px" }} />
        {!isSmallScreen && t('surveySidebar')}
      </Link>
      <Link to="/dashrelatedsummary" style={itemStyle}>
        <RelatedIcon style={{ marginRight: isSmallScreen ? "0" : "10px", fontSize: "50px" }} />
        {!isSmallScreen && t('relatedSidebar')}
      </Link>
    </div>
  );
};

export default SideBar;
